<template>
  <div>
    <div class="md-layout md-alignment-top-center">
      <md-card>
        <md-card-header>
          <h2>Kontakt</h2>
        </md-card-header>

        <md-card-content>
          <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(submit)">
              <div class="md-layout md-alignment-top-left">
                <!-- Vorname -->
                <div class="md-layout-item">
                  <ValidationProvider
                    name="firstname"
                    rules="required|max:150"
                    v-slot="{ passed, failed }"
                  >
                    <md-field>
                      <label>
                        Vorname
                      </label>
                      <md-input
                        required
                        v-model="data.firstName"
                        placeholder="Vorname"
                      ></md-input>
                      <slide-y-down-transition>
                        <md-icon class="error" v-show="failed">close</md-icon>
                      </slide-y-down-transition>
                      <slide-y-down-transition>
                        <md-icon class="success" v-show="passed">done</md-icon>
                      </slide-y-down-transition>
                    </md-field>
                  </ValidationProvider>
                </div>

                <!-- Nachname -->
                <div class="md-layout-item">
                  <ValidationProvider
                    name="lastName"
                    rules="required|max:150"
                    v-slot="{ passed, failed }"
                  >
                    <md-field>
                      <label>
                        Nachname
                      </label>
                      <md-input
                        required
                        v-model="data.lastName"
                        placeholder="Nachname"
                      ></md-input>
                      <slide-y-down-transition>
                        <md-icon class="error" v-show="failed">close</md-icon>
                      </slide-y-down-transition>
                      <slide-y-down-transition>
                        <md-icon class="success" v-show="passed">done</md-icon>
                      </slide-y-down-transition>
                    </md-field>
                  </ValidationProvider>
                </div>

                <!-- Email -->
                <div class="md-layout-item md-size-100">
                  <ValidationProvider
                    name="email"
                    rules="required|email|max:150"
                    v-slot="{ passed, failed }"
                  >
                    <md-field>
                      <label>
                        Email
                      </label>
                      <md-input
                        required
                        v-model="data.email"
                        placeholder="Email"
                      ></md-input>
                      <slide-y-down-transition>
                        <md-icon class="error" v-show="failed">close</md-icon>
                      </slide-y-down-transition>
                      <slide-y-down-transition>
                        <md-icon class="success" v-show="passed">done</md-icon>
                      </slide-y-down-transition>
                    </md-field>
                  </ValidationProvider>
                </div>

                <!-- Telefon -->
                <div class="md-layout-item md-size-100">
                  <ValidationProvider
                    name="tel"
                    rules="required|digits|max:150"
                    v-slot="{ passed, failed }"
                  >
                    <md-field>
                      <label>
                        Telefon
                      </label>
                      <md-input
                        required
                        v-model="data.tel"
                        placeholder="Telefon"
                      ></md-input>
                      <slide-y-down-transition>
                        <md-icon class="error" v-show="failed">close</md-icon>
                      </slide-y-down-transition>
                      <slide-y-down-transition>
                        <md-icon class="success" v-show="passed">done</md-icon>
                      </slide-y-down-transition>
                    </md-field>
                  </ValidationProvider>
                </div>

                <!-- Grund -->
                <div class="md-layout-item">
                  <ValidationProvider name="reason" rules="required|max:150">
                    <md-field>
                      <label>Grund</label>
                      <md-select v-model="data.reason" required>
                        <md-option value="question">Fragen</md-option>
                        <md-option value="web">Webseite</md-option>
                        <md-option value="app">App</md-option>
                        <md-option value="anmeldung">Anmeldung</md-option>
                        <md-option value="dsgvo">Datenschutz</md-option>
                      </md-select>
                    </md-field>
                  </ValidationProvider>
                </div>

                <!-- Event -->
                <div class="md-layout-item">
                  <ValidationProvider
                    name="event"
                    rules="required|max:150"
                    v-slot="{ passed, failed }"
                  >
                    <md-field>
                      <label>
                        Event
                      </label>
                      <md-input
                        required
                        v-model="data.event"
                        placeholder="Event"
                      ></md-input>
                      <slide-y-down-transition>
                        <md-icon class="error" v-show="failed">close</md-icon>
                      </slide-y-down-transition>
                      <slide-y-down-transition>
                        <md-icon class="success" v-show="passed">done</md-icon>
                      </slide-y-down-transition>
                    </md-field>
                  </ValidationProvider>
                </div>

                <!-- Nachricht -->
                <div class="md-layout-item md-size-100">
                  <ValidationProvider
                    name="message"
                    rules="required|max:1000"
                    v-slot="{ passed, failed }"
                  >
                    <md-field>
                      <label>Nachricht</label>
                      <md-textarea
                        required
                        v-model="data.message"
                        md-autogrow
                        md-counter="500"
                      ></md-textarea>
                      <slide-y-down-transition>
                        <md-icon class="error" v-show="failed">close</md-icon>
                      </slide-y-down-transition>
                      <slide-y-down-transition>
                        <md-icon class="success" v-show="passed">done</md-icon>
                      </slide-y-down-transition>
                    </md-field>
                  </ValidationProvider>
                </div>
              </div>
            </form>
          </ValidationObserver>
        </md-card-content>
        <md-card-actions>
          <md-button class="md-success" @click="submit">Abschicken</md-button>
        </md-card-actions>
      </md-card>
    </div>
    <router-link to="/"
      ><md-button class="md-primary">Zurück</md-button></router-link
    >
  </div>
</template>

<script>
import { extend } from "vee-validate";
import { required, email, max, digits } from "vee-validate/dist/rules";

extend("email", email);
extend("required", required);
extend("max", max);
extend("digits", digits);

export default {
  data() {
    return {
      data: {
        firstName: null,
        lastName: null,
        email: null,
        tel: null,
        reason: null,
        event: null,
        message: null
      }
    };
  },
  methods: {
    submit() {
      this.$store
        .dispatch("sendContact", this.data)
        .then(res => {
          console.log(res);
          this.$router.push("/");

          this.$notify({
            timeout: 5000,
            message: "Deine Nachricht wurde versendet.",
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success"
          });
        })
        .catch(err => {
          console.log(err);
          if (err.response && err.response.status === 401) {
            this.$notify({
              timeout: 5000,
              message:
                "Deine Daten sind leider nicht korrekt! Bitte versuche es nochmals.",
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "error"
            });
            this.email = "";
            this.password = "";
          } else if (err.message) {
            this.$notify({
              timeout: 5000,
              message:
                "Ein unerwarteter Fehler ist aufgetretten:" + err.message,
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "error"
            });
          } else {
            this.$notify({
              timeout: 5000,
              message: "Ein unerwarteter Fehler ist aufgetretten!",
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "error"
            });
          }
        });
    }
  },
  mounted() {
    let user = this.$store.getters.user;
    if (user) {
      this.data.firstName = user.firstname;
      this.data.lastName = user.lastname;
      this.data.email = user.email;
    } else console.log("no user");
  }
};
</script>

<style></style>
